import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo/logo-ar.png")